<div class="atlas-table">
  <p-table [showGridlines]="true" sortField="PaymentDate" [sortOrder]="-1" [value]="searchResult.Result" [paginator]="true"
    [rows]="searchParams ? searchParams.PageSize : 10" [lazy]="true" [totalRecords]="searchResult.TotalCount"
    (onLazyLoad)="lazyLoadUnappliedPayments($event)">
    <ng-template pTemplate="sorticon" field="col.field" let-sortOrder>
      <SortAltIcon *ngIf="sortOrder === 0">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-alt" aria-hidden="true"></i></span>
      </SortAltIcon>
      <SortAmountUpAltIcon *ngIf="sortOrder === 1" [styleClass]="'p-sortable-column-icon'">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt" aria-hidden="true"></i></span>
      </SortAmountUpAltIcon>
      <SortAmountDownIcon *ngIf="sortOrder === -1" [styleClass]="'p-sortable-column-icon'">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-down" aria-hidden="true"></i></span>
      </SortAmountDownIcon>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th class="date-column" pSortableColumn="ApplyDate">
          {{ 'revenue.transactions-grid.unapplied-payments.date' | translate | ucfirst }}
          <p-sortIcon field="ApplyDate"></p-sortIcon>
        </th>
        <th pSortableColumn="PaymentType">
          {{ 'revenue.transactions-grid.unapplied-payments.transaction-type' | translate | ucfirst }}
          <p-sortIcon field="PaymentType"></p-sortIcon>
        </th>
        <th [style]="{'text-align': 'right'}" pSortableColumn="Amount">
          {{ 'revenue.transactions-grid.unapplied-payments.amount' | translate | ucfirst }}
          <p-sortIcon field="Amount"></p-sortIcon>
        </th>
        <th [style]="{ width: '120px' }"></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-unappliedPayment>
      <tr>
        <td class="date-column">
          {{ unappliedPayment.ApplyDate | date: 'MM/dd/yyyy' }}
        </td>
        <td>
          <div *ngIf="unappliedPayment.AppliedToPaymentId > 0" class="ws-p f-wb">
            {{ 'revenue.transactions-grid.unapplied-payments.applied-to-invoice' | translate | titlecase }} #{{
            unappliedPayment.InvoiceNumber
            }}
          </div>
          <div *ngIf="unappliedPayment.AppliedToPaymentId === 0">
            {{ unappliedPayment.PaymentType1?.Descr }}
          </div>
        </td>
        <td [style]="{'text-align': 'right'}">
          <div class="w-100" style="text-align: right">
            <div>{{ unappliedPayment.AdjustedAmount | currency: false }}</div>
          </div>
        </td>
        <td class="t-ac">
          <action-button [label]="'common.actions' | translate | uppercase"
            [items]="actionItemsForUnappliedPayment(unappliedPayment)">
          </action-button>
        </td>
      </tr>
    </ng-template>
  </p-table>
  <p-progressSpinner *ngIf="loading"></p-progressSpinner>
</div>

<wl-adjust-unapplied-payment-dialog (adjustmentSaved)="search()"></wl-adjust-unapplied-payment-dialog>

<p-confirmDialog #cd key="deleteUnappliedPaymentCD"
  header="{{ 'revenue.transactions-grid.unapplied-payments.delete-header' | translate | ucfirst }}"
  icon="pi pi-exclamation-triangle">
  <ng-template pTemplate="footer">
    <button pButton type="button" class="atlas-btn atlas-btn-secondary mr-10" (click)="cd.onReject()">
      {{ 'common.cancel' | translate | uppercase }}
    </button>
    <button pButton type="button" class="atlas-btn atlas-btn-danger" (click)="cd.onAccept('test')">
      {{ 'common.delete' | translate | uppercase }}
    </button>
  </ng-template>
</p-confirmDialog>

<p-confirmDialog #refundCD key="refundCreditCardCD"
  header="{{ 'revenue.transactions-grid.unapplied-payments.credit-refund-header' | translate | ucfirst }}"
  icon="pi pi-question">
  <ng-template pTemplate="footer">
    <button pButton type="button" class="atlas-btn atlas-btn-primary" (click)="refundCD.accept()">
      {{ 'revenue.transactions-grid.unapplied-payments.refund-charge' | translate | uppercase }}
    </button>
    <button pButton type="button" class="atlas-btn atlas-btn-secondary" (click)="deleteWithoutRefunding()">
      {{ 'revenue.transactions-grid.unapplied-payments.delete-without-refunding' | translate | uppercase }}
    </button>
    <button pButton type="button" class="atlas-btn atlas-btn-secondary mr-10" (click)="refundCD.reject()">
      {{ 'common.cancel' | translate | uppercase }}
    </button>
  </ng-template>
</p-confirmDialog>
